/*!
 * witness.js - witness object for bcoin
 * Copyright (c) 2014-2015, Fedor Indutny (MIT License)
 * Copyright (c) 2014-2017, Christopher Jeffrey (MIT License).
 * https://github.com/bcoin-org/bcoin
 */
'use strict';

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var assert = require('bsert');

var bio = require('bufio');

var Script = require('./script');

var common = require('./common');

var Address = require('../primitives/address');

var Stack = require('./stack');

var encoding = bio.encoding;
var scriptTypes = common.types;

var _require = require('../utils'),
    inspectSymbol = _require.inspectSymbol;
/**
 * Witness
 * Refers to the witness vector of
 * segregated witness transactions.
 * @alias module:script.Witness
 * @extends Stack
 * @property {Buffer[]} items
 * @property {Script?} redeem
 * @property {Number} length
 */


var Witness = /*#__PURE__*/function (_Stack) {
  _inherits(Witness, _Stack);

  var _super = _createSuper(Witness);

  /**
   * Create a witness.
   * @alias module:script.Witness
   * @constructor
   * @param {Buffer[]|Object} items - Array of
   * stack items.
   * @property {Buffer[]} items
   * @property {Script?} redeem
   * @property {Number} length
   */
  function Witness(options) {
    var _this;

    _classCallCheck(this, Witness);

    _this = _super.call(this);
    if (options) _this.fromOptions(options);
    return _this;
  }
  /**
   * Inject properties from options object.
   * @private
   * @param {Object} options
   */


  _createClass(Witness, [{
    key: "fromOptions",
    value: function fromOptions(options) {
      assert(options, 'Witness data is required.');
      if (Array.isArray(options)) return this.fromArray(options);
      if (options.items) return this.fromArray(options.items);
      return this;
    }
    /**
     * Instantiate witness from options.
     * @param {Object} options
     * @returns {Witness}
     */

  }, {
    key: "toArray",

    /**
     * Convert witness to an array of buffers.
     * @returns {Buffer[]}
     */
    value: function toArray() {
      return this.items.slice();
    }
    /**
     * Inject properties from an array of buffers.
     * @private
     * @param {Buffer[]} items
     */

  }, {
    key: "fromArray",
    value: function fromArray(items) {
      assert(Array.isArray(items));
      this.items = items;
      return this;
    }
    /**
     * Insantiate witness from an array of buffers.
     * @param {Buffer[]} items
     * @returns {Witness}
     */

  }, {
    key: "toItems",

    /**
     * Convert witness to an array of buffers.
     * @returns {Buffer[]}
     */
    value: function toItems() {
      return this.items.slice();
    }
    /**
     * Inject properties from an array of buffers.
     * @private
     * @param {Buffer[]} items
     */

  }, {
    key: "fromItems",
    value: function fromItems(items) {
      assert(Array.isArray(items));
      this.items = items;
      return this;
    }
    /**
     * Insantiate witness from an array of buffers.
     * @param {Buffer[]} items
     * @returns {Witness}
     */

  }, {
    key: "toStack",

    /**
     * Convert witness to a stack.
     * @returns {Stack}
     */
    value: function toStack() {
      return new Stack(this.toArray());
    }
    /**
     * Inject properties from a stack.
     * @private
     * @param {Stack} stack
     */

  }, {
    key: "fromStack",
    value: function fromStack(stack) {
      return this.fromArray(stack.items);
    }
    /**
     * Insantiate witness from a stack.
     * @param {Stack} stack
     * @returns {Witness}
     */

  }, {
    key: inspectSymbol,

    /**
     * Inspect a Witness object.
     * @returns {String} Human-readable script.
     */
    value: function value() {
      return "<Witness: ".concat(this.toString(), ">");
    }
    /**
     * Clone the witness object.
     * @returns {Witness} A clone of the current witness object.
     */

  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().inject(this);
    }
    /**
     * Inject properties from witness.
     * Used for cloning.
     * @private
     * @param {Witness} witness
     * @returns {Witness}
     */

  }, {
    key: "inject",
    value: function inject(witness) {
      this.items = witness.items.slice();
      return this;
    }
    /**
     * Compile witness (NOP).
     * @returns {Witness}
     */

  }, {
    key: "compile",
    value: function compile() {
      return this;
    }
    /**
     * "Guess" the type of the witness.
     * This method is not 100% reliable.
     * @returns {ScriptType}
     */

  }, {
    key: "getInputType",
    value: function getInputType() {
      if (this.isPubkeyhashInput()) return scriptTypes.WITNESSPUBKEYHASH;
      if (this.isScripthashInput()) return scriptTypes.WITNESSSCRIPTHASH;
      return scriptTypes.NONSTANDARD;
    }
    /**
     * "Guess" the address of the witness.
     * This method is not 100% reliable.
     * @returns {Address|null}
     */

  }, {
    key: "getInputAddress",
    value: function getInputAddress() {
      return Address.fromWitness(this);
    }
    /**
     * "Test" whether the witness is a pubkey input.
     * Always returns false.
     * @returns {Boolean}
     */

  }, {
    key: "isPubkeyInput",
    value: function isPubkeyInput() {
      return false;
    }
    /**
     * Get P2PK signature if present.
     * Always returns null.
     * @returns {Buffer|null}
     */

  }, {
    key: "getPubkeyInput",
    value: function getPubkeyInput() {
      return null;
    }
    /**
     * "Guess" whether the witness is a pubkeyhash input.
     * This method is not 100% reliable.
     * @returns {Boolean}
     */

  }, {
    key: "isPubkeyhashInput",
    value: function isPubkeyhashInput() {
      return this.items.length === 2 && common.isSignatureEncoding(this.items[0]) && common.isKeyEncoding(this.items[1]);
    }
    /**
     * Get P2PKH signature and key if present.
     * @returns {Array} [sig, key]
     */

  }, {
    key: "getPubkeyhashInput",
    value: function getPubkeyhashInput() {
      if (!this.isPubkeyhashInput()) return [null, null];
      return [this.items[0], this.items[1]];
    }
    /**
     * "Test" whether the witness is a multisig input.
     * Always returns false.
     * @returns {Boolean}
     */

  }, {
    key: "isMultisigInput",
    value: function isMultisigInput() {
      return false;
    }
    /**
     * Get multisig signatures key if present.
     * Always returns null.
     * @returns {Buffer[]|null}
     */

  }, {
    key: "getMultisigInput",
    value: function getMultisigInput() {
      return null;
    }
    /**
     * "Guess" whether the witness is a scripthash input.
     * This method is not 100% reliable.
     * @returns {Boolean}
     */

  }, {
    key: "isScripthashInput",
    value: function isScripthashInput() {
      return this.items.length > 0 && !this.isPubkeyhashInput();
    }
    /**
     * Get P2SH redeem script if present.
     * @returns {Buffer|null}
     */

  }, {
    key: "getScripthashInput",
    value: function getScripthashInput() {
      if (!this.isScripthashInput()) return null;
      return this.items[this.items.length - 1];
    }
    /**
     * "Guess" whether the witness is an unknown/non-standard type.
     * This method is not 100% reliable.
     * @returns {Boolean}
     */

  }, {
    key: "isUnknownInput",
    value: function isUnknownInput() {
      return this.getInputType() === scriptTypes.NONSTANDARD;
    }
    /**
     * Test the witness against a bloom filter.
     * @param {Bloom} filter
     * @returns {Boolean}
     */

  }, {
    key: "test",
    value: function test(filter) {
      var _iterator = _createForOfIteratorHelper(this.items),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (item.length === 0) continue;
          if (filter.test(item)) return true;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return false;
    }
    /**
     * Grab and deserialize the redeem script from the witness.
     * @returns {Script} Redeem script.
     */

  }, {
    key: "getRedeem",
    value: function getRedeem() {
      if (this.items.length === 0) return null;
      var redeem = this.items[this.items.length - 1];
      if (!redeem) return null;
      return Script.fromRaw(redeem);
    }
    /**
     * Find a data element in a witness.
     * @param {Buffer} data - Data element to match against.
     * @returns {Number} Index (`-1` if not present).
     */

  }, {
    key: "indexOf",
    value: function indexOf(data) {
      for (var i = 0; i < this.items.length; i++) {
        var item = this.items[i];
        if (item.equals(data)) return i;
      }

      return -1;
    }
    /**
     * Calculate size of the witness
     * excluding the varint size bytes.
     * @returns {Number}
     */

  }, {
    key: "getSize",
    value: function getSize() {
      var size = 0;

      var _iterator2 = _createForOfIteratorHelper(this.items),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;
          size += encoding.sizeVarBytes(item);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return size;
    }
    /**
     * Calculate size of the witness
     * including the varint size bytes.
     * @returns {Number}
     */

  }, {
    key: "getVarSize",
    value: function getVarSize() {
      return encoding.sizeVarint(this.items.length) + this.getSize();
    }
    /**
     * Write witness to a buffer writer.
     * @param {BufferWriter} bw
     */

  }, {
    key: "toWriter",
    value: function toWriter(bw) {
      bw.writeVarint(this.items.length);

      var _iterator3 = _createForOfIteratorHelper(this.items),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var item = _step3.value;
          bw.writeVarBytes(item);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return bw;
    }
    /**
     * Encode the witness to a Buffer.
     * @param {String} enc - Encoding, either `'hex'` or `null`.
     * @returns {Buffer|String} Serialized script.
     */

  }, {
    key: "toRaw",
    value: function toRaw() {
      var size = this.getVarSize();
      return this.toWriter(bio.write(size)).render();
    }
    /**
     * Convert witness to a hex string.
     * @returns {String}
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.toRaw().toString('hex');
    }
    /**
     * Inject properties from json object.
     * @private
     * @param {String} json
     */

  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      assert(typeof json === 'string', 'Witness must be a string.');
      return this.fromRaw(Buffer.from(json, 'hex'));
    }
    /**
     * Insantiate witness from a hex string.
     * @param {String} json
     * @returns {Witness}
     */

  }, {
    key: "fromReader",

    /**
     * Inject properties from buffer reader.
     * @private
     * @param {BufferReader} br
     */
    value: function fromReader(br) {
      var count = br.readVarint();

      for (var i = 0; i < count; i++) {
        this.items.push(br.readVarBytes());
      }

      return this;
    }
    /**
     * Inject properties from serialized data.
     * @private
     * @param {Buffer} data
     */

  }, {
    key: "fromRaw",
    value: function fromRaw(data) {
      return this.fromReader(bio.read(data));
    }
    /**
     * Create a witness from a buffer reader.
     * @param {BufferReader} br
     */

  }, {
    key: "fromString",

    /**
     * Inject items from string.
     * @private
     * @param {String|String[]} items
     */
    value: function fromString(items) {
      if (!Array.isArray(items)) {
        assert(typeof items === 'string');
        items = items.trim();
        if (items.length === 0) return this;
        items = items.split(/\s+/);
      }

      var _iterator4 = _createForOfIteratorHelper(items),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var item = _step4.value;
          this.items.push(Buffer.from(item, 'hex'));
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return this;
    }
    /**
     * Parse a test script/array
     * string into a witness object. _Must_
     * contain only stack items (no non-push
     * opcodes).
     * @param {String|String[]} items - Script string.
     * @returns {Witness}
     * @throws Parse error.
     */

  }], [{
    key: "fromOptions",
    value: function fromOptions(options) {
      return new this().fromOptions(options);
    }
  }, {
    key: "fromArray",
    value: function fromArray(items) {
      return new this().fromArray(items);
    }
  }, {
    key: "fromItems",
    value: function fromItems(items) {
      return new this().fromItems(items);
    }
  }, {
    key: "fromStack",
    value: function fromStack(stack) {
      return new this().fromStack(stack);
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      return new this().fromJSON(json);
    }
  }, {
    key: "fromReader",
    value: function fromReader(br) {
      return new this().fromReader(br);
    }
    /**
     * Create a witness from a serialized buffer.
     * @param {Buffer|String} data - Serialized witness.
     * @param {String?} enc - Either `"hex"` or `null`.
     * @returns {Witness}
     */

  }, {
    key: "fromRaw",
    value: function fromRaw(data, enc) {
      if (typeof data === 'string') data = Buffer.from(data, enc);
      return new this().fromRaw(data);
    }
  }, {
    key: "fromString",
    value: function fromString(items) {
      return new this().fromString(items);
    }
    /**
     * Test an object to see if it is a Witness.
     * @param {Object} obj
     * @returns {Boolean}
     */

  }, {
    key: "isWitness",
    value: function isWitness(obj) {
      return obj instanceof Witness;
    }
  }]);

  return Witness;
}(Stack);
/*
 * Expose
 */


module.exports = Witness;